"use client";

import { Share2, UserPlus, CreditCard, Gift } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/app/_module/components/ui/card";

const STEPS = [
  {
    icon: Share2,
    title: "Share Your Link",
    description: "Copy your unique referral link and share it with fellow insurance agents.",
    color: "text-blue-600",
    bg: "bg-blue-50",
  },
  {
    icon: UserPlus,
    title: "They Sign Up",
    description: "When an agent signs up using your link, they're tracked as your referral.",
    color: "text-green-600",
    bg: "bg-green-50",
  },
  {
    icon: CreditCard,
    title: "They Subscribe",
    description: "Once your referral subscribes to a paid plan, the reward is triggered.",
    color: "text-amber-600",
    bg: "bg-amber-50",
  },
  {
    icon: Gift,
    title: "Both Get 1 Free Month",
    description: "You and your referral each receive 1 free month of your subscription.",
    color: "text-purple-600",
    bg: "bg-purple-50",
  },
];

export default function HowItWorksSection() {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base">How It Works</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {STEPS.map((step, i) => (
            <div key={step.title} className="flex flex-col items-center text-center p-3">
              <div className="relative mb-3">
                <div className={`w-12 h-12 rounded-full ${step.bg} flex items-center justify-center`}>
                  <step.icon className={`h-6 w-6 ${step.color}`} />
                </div>
                <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-gray-900 text-white text-xs flex items-center justify-center font-bold">
                  {i + 1}
                </span>
              </div>
              <h4 className="font-semibold text-sm text-gray-900 mb-1">
                {step.title}
              </h4>
              <p className="text-xs text-gray-500">{step.description}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
